import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import Sidebar from './Sidebar';

class ProductProps extends Component {
  handleNext() {
    const { name, subtype } = this.props.fields;

    if (!name) {
      this.props.alert('error', 'Please provide the title of this work.');
    } else if (!subtype) {
      this.props.alert(
        'error',
        'Please specify what type of work this is by clicking on "Select work type".'
      );
    } else {
      this.props.hideAlert();
      this.props.router.push('/create/select-team');
    }
  }

  renderSelect() {
    const { fields, subWorkTypes } = this.props;

    return (
      <div className="subtype-select">
        <select
          defaultValue={fields.subtype}
          onChange={(e) =>
            this.props.assignAttribute('subtype', e.target.value)
          }
        >
          <option value="" disabled hidden>
            Select work type
          </option>
          {subWorkTypes.map((subWorkType, i) => {
            if (subWorkType.work_type === fields.type) {
              return (
                <option key={i} value={subWorkType.id}>
                  {subWorkType.name}
                </option>
              );
            } else {
              return null;
            }
          })}
        </select>
      </div>
    );
  }

  render() {
    const { name, type, agreementStartType } = this.props.fields;

    return (
      <div className="product-props side">
        <Heading text="Tell us more about this work" />
        <div className="content">
          <Sidebar />
          <div className="main">
            <div className="input-group">
              <input
                type="text"
                placeholder="What is the title of the work?"
                value={name}
                onChange={(e) =>
                  this.props.assignAttribute('name', e.target.value)
                }
              />
              {this.renderSelect()}
            </div>
            {type === 1 ? (
              <div>
                <p>
                  Select "Music Composition + Sound Recording" as your work type
                  only if all of the collaborators on your team will own both
                  the musical composition (lyrics and melody) and the sound
                  recording (the actual audio created) and if each
                  collaborator's ownership in both the musical composition and
                  the sound recording will be identical.
                </p>
                <ul>
                  <li>
                    Applicable Example: Alex owns <strong>25%</strong> of the
                    copyright of the musical composition and Anne owns the
                    remaining <strong>75%</strong>. Alex also owns{' '}
                    <strong>25%</strong> of the copyright of the sound recording
                    and Anne owns the remaining <strong>75%</strong>.
                  </li>
                  <li>
                    Not Applicable: Alex owns <strong>25%</strong> of the
                    copyright of the musical composition and Anne owns the
                    remaining <strong>75%</strong>. Alex also owns{' '}
                    <strong>50%</strong> of the copyright of the sound recording
                    and Anne owns the remaining <strong>50%</strong>. In this
                    instance, you should use Cosynd to create two separate
                    ownership agreements - one for the musical composition and
                    one for the sound recording.
                  </li>
                </ul>
              </div>
            ) : null}
            <div>
              If you created multiple works with the same collaborators who will
              have the same ownership splits in each work, you can list all of
              the work titles now. Separate each title using a semi-colon (;).
              Not sure what work type to select?{' '}
              <a
                href="https://cosynd.zendesk.com/hc/en-us/articles/115015908447"
                target="_blank"
              >
                Click here for help.
              </a>
            </div>
          </div>
        </div>
        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => this.props.router.push(`/create/${agreementStartType}`)}
          />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.create.fields,
  workTypes: state.global.workTypes,
  subWorkTypes: state.global.subWorkTypes,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignAttribute(field, attribute));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductProps);



// WEBPACK FOOTER //
// src/components/Create/ProductProps.jsx